import { useCallback, useEffect } from 'react';
import { useSelector } from 'react-redux';

import useActions from './useActions';
import { fetchResult } from 'actions';

const useResult = (id) => {
  const dispatchFetchResult = useActions(fetchResult);

  const results = useSelector(
    ({ result }) => result.currentResult,
  );

  const memoizedFetch = useCallback(() => dispatchFetchResult(id, {onSuccess: () => console.log("yooo")}),
    [dispatchFetchResult, id],
  );

  useEffect(() => {
    memoizedFetch();
  }, [memoizedFetch]);

  return results;
};

export default useResult;
